export default "__VITE_ASSET___pTezIZ$__"